<template>
  <v-container id="taxslabs" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </div>

    <v-dialog v-model="statusUpdate" transition="dialog-top-transition" width="600">
      <v-card>
        <v-toolbar dark color="primary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-chat</v-icon>
            {{ $i18n.t("Change Status") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="statusUpdate = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-select
                :items="statusList"
                item-text="value"
                item-value="name"
                v-model="incident.status"
                :label="$i18n.t('Status')"
              />
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea v-model="incident.comment" :label="$i18n.t('Add Comment')" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            class="mr-0"
            small
            dark
            @click="changeStatusSave()"
            :loading="loading"
          >
            <v-icon>mdi-cloud-upload</v-icon>
            &nbsp;
            {{$i18n.t('Save')}}
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th class="primary--text">{{ $i18n.t("Comment") }}</th>
                <th class="primary--text">{{ $i18n.t("Comment By") }}</th>
                <th class="primary--text">{{ $i18n.t("At") }}</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(c, index) in incident.commentTOS" :key="index">
                <td>{{ c.msg }}</td>
                <td>{{ c.commentBy }}</td>
                <td>{{c.at | moment("DD MMM YYYY hh:mm a")}}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('From Date')"
                class="purple-input"
                v-model="filters.startDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                class="purple-input"
                v-model="filters.endDate"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                :items="statusList"
                item-text="value"
                item-value="name"
                :label="$i18n.t('Status')"
                class="purple-input"
                v-model="filters.status"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Trip No')"
                class="purple-input"
                v-model="filters.tripNo"
              />
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Incidents')"
      class="px-5 py-3"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("No") }}</th>
            <th class="primary--text">{{ $i18n.t("Image") }}</th>
            <th class="primary--text">{{ $i18n.t("Trip No") }}</th>
            <th class="primary--text">{{ $i18n.t("Vendor") }}</th>
            <th class="primary--text">{{ $i18n.t("Driver") }}</th>
            <th class="primary--text">{{ $i18n.t("User") }}</th>
            <th class="primary--text">{{ $i18n.t("Issue") }}/{{$i18n.t("Detail")}}</th>
            <th class="primary--text">{{ $i18n.t("Time") }}</th>
            <th class="primary--text">{{ $i18n.t("Status") }}</th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="bu in grid.rows" :key="bu._id">
            <td>{{ bu.no }}</td>
            <td>
              <v-img width="70" v-if="bu.pics && bu.pics.length > 0" :src="bu.pics[0].url" />
            </td>
            <td>
              <a :href="'/trip/' + bu.booking_id">{{bu.tripNo}}</a>
            </td>
            <td>{{ bu.vendorName }}</td>
            <td>
              <p>{{bu.driverName}}</p>
              <p>{{bu.driverPhone != null ? (bu.countryCode != null ? (bu.countryCode) : '91') + '-' + bu.driverPhone : ''}}</p>
            </td>
            <td>
              <p>{{bu.userName}}</p>
              <p>{{bu.userPh != null ? (bu.userCC != null ? (bu.userCC) : '91') + '-' + bu.userPh : ''}}</p>
            </td>
            <td>
              <p>{{bu.issue}}</p>
              <p>{{bu.detail}}</p>
            </td>
            <td>{{bu.at | moment("DD MMM YYYY hh:mm a")}}</td>
            <td>{{ bu.statusStr }}</td>
            <td>
              <v-btn
                class="float-right"
                style="color:aqua"
                small
                fab
                text
                dark
                @click="changeStatus(bu)"
                v-on="on"
              >
                <v-icon>mdi-chat</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class TaxSlabs extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/incident/grid?rows=" + this.rows;
  showFilter = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  incident = {};
  statusUpdate = false;
  savedStatus = null;
  filters = { startDate: null, endDate: null, status: null, tripNo: null };
  statusList = [
    { name: 0, value: "Open" },
    { name: 1, value: "Resolved" },
    { name: 2, value: "Assigned" },
  ];

  get loading() {
    return common.loading;
  }

  async changeStatusSave() {
    if (!this.incident._id) {
      common.setError("Please provide incident");
      return;
    }
    if (!this.incident.comment) {
      common.setError("Please provide comment");
      return;
    }
    if (this.savedStatus == 1 && this.incident.status == 0) {
      common.setError("Resolved status cannot be changed");
      return;
    }
    common.setLoading(true);
    try {
      await doPost("/api/incident/update", this.incident);
      this.showPage(this.page);
      common.showMessage("Status Updated");
      common.setLoading(false);
      this.statusUpdate = false;
      this.incident = {};
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  changeStatus = function (_incident) {
    this.savedStatus = Object.assign({}, _incident.status);
    this.incident = Object.assign({}, _incident);
    this.statusUpdate = true;
  };

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.startDate)
      this.filterUrl += "&startDate=" + this.filters.startDate;
    if (this.filters.endDate)
      this.filterUrl += "&endDate=" + this.filters.endDate;
    if (this.filters.status) this.filterUrl += "&status=" + this.filters.status;
    if (this.filters.tripNo) this.filterUrl += "&tripNo=" + this.filters.tripNo;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deletebu(bu) {
    try {
      await doGet("/api/taxslab/" + bu._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
